export function hasLoadedFundingProgramProperties(
  fundingProgramProperties: readonly unknown[] | undefined,
): boolean {
  return fundingProgramProperties !== undefined;
}
